module.exports = __webpack_public_path__ + "static/map_usa_SO-b57def23ffde1adf53bfea38d42a23bd.png";